import { render, staticRenderFns } from "./WorkflowInvocation.vue?vue&type=template&id=166f4535&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./WorkflowInvocation.vue?vue&type=script&lang=js&"
export * from "./WorkflowInvocation.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowInvocation.vue?vue&type=style&index=0&id=166f4535&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166f4535",
  null
  
)

export default component.exports